import { API } from "./static.data.pnp";

export const urlApi = {

    getOtp: API + "/primary/auth/user/login",
    verifyOtp: API + "/primary/auth/user/verify-otp",
    logOut: API + "/primary/user/logout",
    googleLogin: API + "/primary/auth/google",
    autoLogin: API + "/primary/auth/user/auto-login",

    // STATIC
    imageUploadApi: API + "/general/upload/file/image-upload",
    fileUploadApi: API + "/general/upload/file/file-upload",
    searchActiveLinks: API + "/general/link/active-link-list",
    getShortLinkDomainList: API + "/general/page/short-link-domains",
    getMyProfileData: API + "/primary/user/profile",
    getSettingData: API + "/general/publish/setting/details/1",

    // ORGANIZATION
    createOrganization: API + "/primary/organization/create",
    getOrganizationList: API + "/primary/organization/list",
    getOrganizationListDetailedData: API + "/primary/organization/list-detailed",
    switchOrganization: API + "/primary/organization/select/",
    getOrgDetailsByOrgId: API + "/primary/organization/details/",
    updateOrgDetails: API + "/primary/organization/update-details",
    getOrganizationDetailsForChat: API + "/primary/organization/details-for-chat/",
    updateOrganizationDetailsForChat: API + "/primary/organization/update-details-for-chat",

    // DASHBOARD
    getDashboardCardsData: API + "/analytics/link-analytics/card-data",
    getDeviceDonutChartData: API + "/analytics/link-analytics/device-data",
    getLocationData: API + "/analytics/link-analytics/country-data",
    topPerformGraphData: API + "/analytics/link-analytics/dashboard-graph/",
    getTopFiveList: API + "/general/link/list-top/",
    getReferredData: API + "/analytics/link-analytics/referrer-data",

    // ATTRIBUTION DASHBOARD
    getAttributionCardData: API + "/analytics/promotion/dashboard/cards",
    getOrganicInorganicGraphData: API + "/analytics/promotion/dashboard/organic-inorganic-count",
    getAttributionGraphData: API + "/analytics/promotion/dashboard/attribution-graph",
    getAttributionTableData: API + "/analytics/promotion/dashboard/attribution-table",

    // LINK
    createLink: API + "/general/link/shorten",
    checkCustomBackHalf: API + "/general/link/check-custom-back-half",
    uploadBulkLinkCsv: API + "/general/upload/file/links-upload",
    getLinkList: API + "/general/link/list",
    deleteLink: API + "/general/link/delete/",
    setLinkExpiration: API + "/general/link/set-expiry",

    // QR
    createQr: API + "/general/qr/generate",
    shortenLinkForQr: API + "/general/link/shorten-qr",
    gelAllQrList: API + "/general/qr/list",
    deleteQr: API + "/general/qr/delete/",
    updateQr: API + "/general/link/update-main-link",

    // PAGES
    getAllPages: API + "/general/page/list",
    createPageLink: API + "/general/page/create",
    getPageDetailsByPageId: API + "/general/page/details/",
    editPageData: API + "/general/page/edit",
    addBlock: API + "/general/page/add-block/",
    updateBlockPosition: API + "/general/page/block-position-set/",
    updateBlockStatus: API + "/general/page/edit-block-status/",
    updateBlockDetails: API + "/general/page/edit-block-image/",
    updateBlockImageStatus: API + "/general/page/edit-block-image-status/",
    getYoutubeDataFromLink: API + "/general/page/youtube-data",
    addBlockImage: API + "/general/page/add-block-image/",
    blockImagePositionChange: API + "/general/page/block-image-position-set/",
    publishPage: API + "/general/page/publish/",
    getSubLinksOfPage: API + "/general/page/sub-links/",
    deletePage: API + "/general/page/delete/",
    templateList: API + "/general/page/templates",

    // IMPORT PAGE
    importPage: API + "/general/page-converter/",

    // BUSINESS CARD
    createBusinessCardLink: API + "/general/business-card/create",
    getCardTemplates: API + "/general/business-card/templates",
    getAnalyticsCardsData: API + "/general/business-card/analytics-data",
    getBusinessCardList: API + "/general/business-card/list",
    getBusinessCardDetailsById: API + "/general/business-card/details/",
    changePositionOfCardBlocks: API + "/general/business-card/block-position-set/",
    editDesignOfCard: API + "/general/business-card/card-design",
    editBlockDataOfCard: API + "/general/business-card/block-data",
    deleteCard: API + "/general/business-card/delete/",
    deleteImageOfCard: API + "/general/business-card/delete-image",
    publishBusinessCard: API + "/general/business-card/publish-card/",
    subLinksOfCard: API + "/general/business-card/sub-links/",
    createQrOfBusinessCard: API + "/general/business-card/add-qr",

    // ANALYSIS
    getAnalysisGraphData: API + "/analytics/link-analytics/dashboard-graph-by-link/",
    getAnalysisLocationTableData: API + "/analytics/link-analytics/country-data-by-link/",
    browserDonutChartData: API + "/analytics/link-analytics/browser-data-by-link/",
    operatingSystemDonutChartData: API + "/analytics/link-analytics/os-data-by-link/",

    // SUPPORT
    getIssueList: API + "/general/issue/list",
    submitIssue: API + "/general/issue/submit",

    // REWARDS
    getRewardsList: API + "/general/reward/list",
    getRewardCardData: API + "/general/reward/cards",
    addBankDetails: API + "/general/reward/add-bank-account",
    withdrawReward: API + "/general/reward/withdraw-request",
    getCurrentBankDetails: API + "/general/reward/get-bank-account",

    // REFERRAL
    applyReferCode: API + "/primary/referral/apply",
    myReferredList: API + "/primary/referral/my-referrals",
    claimReward: API + "/primary/referral/claim-reward/",

    // SETTINGS
    updateProfile: API + "/primary/user/profile-update",
    getOtpForUpdate: API + "/primary/user/send-otp",
    verifyCredential: API + "/primary/user/add-credential",
    ingestSite: API + "/ai-chatbot/auth/main/ingest",

    //TEAM
    getTeamMemberList: API + "/general/setting/team-members",
    updateTeamMemberStatus: API + "/primary/organization/member-status-update/",
    assignLiveChatAccess: API + "/general/access/assign-chat-preset/",

    // INVITATION
    inviteMember: API + "/primary/organization/invite-member",
    responseInvite: API + "/primary/auth/organization/join-member/",

    // ACCESS
    getStaticAccessList: API + "/general/publish/access/list-all",
    accessPresetList: API + "/general/access/list-presets",
    assignAccessToMember: API + "/general/access/assign-preset/",
    createAccessPreset: API + "/general/access/create-preset",
    updateAccessPreset: API + "/general/access/edit-preset",
    getMyAccess: API + "/general/access/my-access",

    // META ADS
    getMetaAdsCampaignList: API + "/general/meta/campaign-list",
    getMetaAdsSetList: API + "/general/meta/ad-set-list",
    getMetaAdList: API + "/general/meta/ad-list",
    updateMetaAdsCredentials: API + "/general/meta/add-credentials",
    metaAccountList: API + "/general/meta/list-credentials",
    syncMetaAdsCampaign: API + "/general/meta/sync-campaign",
    getMetaGraphData: API + "/general/meta/analytics-graph",
    getMetaAdCards: API + "/general/meta/analytics-cards",

    // GOOGLE ADS
    updateGoogleAdsCredentials: API + "/general/google-ads/add-client-id",
    addGoogleManagerAccount: API + "/general/google-ads/add-manager-credentials",
    getGoogleAdsManagerAccount: API + "/general/google-ads/manager-credentials",
    updateGoogleAdsMangerAccountData: API + "/general/google-ads/update-manager-credentials",
    getGoogleAccountList: API + "/general/google-ads/list-credentials",
    syncGoogleAdsCampaign: API + "/general/google-ads/sync",
    getGoogleCampaignList: API + "/general/google-ads/campaign-list",
    getGoogleAdsGroupList: API + "/general/google-ads/ad-group-list",
    getGoogleAdsList: API + "/general/google-ads/ad-list",
    getGoogleAdsCardData: API + "/general/google-ads/card-data",
    getGoogleAdsGraphData: API + "/general/google-ads/graph-data",

    // PRICE & PLAN
    requestPlan: API + "/general/plan/submit-request",
    getPlanList: API + "/payment/plan/list",
    buyPlan: API + "/payment/phonepe/payment-token/",
    buyPlanUSD: API + "/payment/payu/payment-token/",

    // AGENT
    addAgent: API + "/general/agent/create",
    agentList: API + "/general/agent/list/",
    agentUpdate: API + "/general/agent/update/",
    agentDetails: API + "/general/agent/details/",
    agentStatusUpdate: API + "/general/agent/update-status/",
    addPaymentMethodOfAgent: API + "/general/agent/add-payment-account/",
    agentPaymentAccountsList: API + "/general/agent/payment-accounts/",
    addGstNumberOfAgent: API + "/general/agent/update-gst/",
    addPanNumberOfAgent: API + "/general/agent/update-pan/",
    influencerListOfAgent: API + "/general/influencer/list/",
    searchAgent: API + "/general/agent/search-list",
    linkInfluencerToAgent: API + "/general/agent/link-existing-influencer/",

    // INFLUENCER
    addInfluencer: API + "/general/influencer/create",
    getInfluencerList: API + "/general/influencer/list",
    updateInfluencer: API + "/general/influencer/update/",
    updateInfluencerStatus: API + "/general/influencer/update-status/",
    influencerDetails: API + "/general/influencer/details/",
    agentListOfInfluencer: API + "/general/agent/list/",
    searchInfluencer: API + "/general/influencer/search-list",
    linkAgentToInfluencer: API + "/general/influencer/link-existing-agent/",
    unLinkAgentInfluencer: API + "/general/agent/unlink-influencer/",

    // PRODUCT
    getProductDetails: API + "/general/product/details",
    registerProduct: API + "/general/product/register",
    updateProduct: API + "/general/product/update",
    addApp: API + "/general/product/add-app",
    appList: API + "/general/product/apps",
    updateApp: API + "/general/product/update-app",
    getCdnData: API + "/general/product/cdn",
    getWebhookData: API + "/general/product/s2s-webhook",
    updateFallbackUrl: API + "/general/product/update-app-fallback",

    addPredefinedPromotionalUrl: API + "/general/product/add-promotion-link",
    getPredefinedPromotionUrlList: API + "/general/product/promotion-link-list",
    updatePredefinePromotionalUrl: API + "/general/product/update-promotion-link",

    // PROMOTION
    createPromotion: API + "/general/promotion/create",
    checkCustomBackHalfForPromotion: API + "/general/promotion/check-back-half",
    promotionList: API + "/general/promotion/list",
    updatePromotionDetails: API + "/general/promotion/update-destination-link",
    deletePromotion: API + "/general/promotion/delete-promo-link/",
    checkAgentInfluencerLinkStatus: API + "/general/promotion/agent-influencer-bond/",
    checkPromotionDestinationLink: API + "/general/promotion/check-destination-link",
    getEventDetailsOfPromotion: API + "/analytics/promotion/event-details/",
    getRevenueEventDetailsOfPromotion: API + "/analytics/promotion/revenue-event-details/",
    getEventLogs: API + "/analytics/promotion/logs",

    // LIVE CHAT
    getVisitorList: API + "/chat/session/list",
    getChatSessionCounts: API + "/chat/session/chat-counts",
    getOldMessages: API + "/chat/session/messages/",
    getBeautifyMsg: API + "/chat/session/beautify-message",
    assignColorForVisitor: API + "/chat/color/assign/",
    markAsUnresolvedChat: API + "/chat/session/unresolve/",

    // CANNED REPLY
    getCannedReplyList: API + "/chat/canned-replies/list",
    createCannedReply: API + "/chat/canned-replies/add",
    updateCannedReply: API + "/chat/canned-replies/update",
    updateStatusOfCannedReply: API + "/chat/canned-replies/status-update",

    // CHAT FEEDBACK
    getChatFeedbackList: API + "/chat/session/feedback-list",

    // CHAT VISITOR
    getVisitorDetails: API + "/chat/visitor/details/",
    getVisitorsPreviousChatSessions: API + "/chat/session/list-by-visitor/",

    // CHAT VISITOR NOTE 
    addVisitorNoteInChat: API + "/chat/note/add",
    getVisitorNoteList: API + "/chat/note/list/",
    deleteVisitorNote: API + "/chat/note/delete/",

    // CHAT REPORT
    chatCountActivityGraph: API + "/chat/report/chat-count-graph",
    chatAnalysisCardsData: API + "/chat/report/cards",
    chatOperatorList: API + "/chat/operator/list",
    chatOperatorAnalysis: API + "/chat/operator/pie-chart/",
    chatFeedbackAnalysis: API + "/chat/report/feedback-analysis",

    // CHAT SETTINGS
    getChatSettingData: API + "/chat/session/chat-setting",
    setChatAutoResolveDuration: API + "/chat/session/set-auto-close-duration",
    getLanguageList: API + "/chat/static/languages",
    setLanguageForChat: API + "/chat/session/set-language/",
    uploadPdf: API + "/chat/upload/file/pdf-upload",
    ingestPdf: API + "/ai-chatbot/auth/main/ingest-pdf",
    toggleCallFeature: API + "/chat/product/update-call-status/",
    addChatHighlightColor: API + "/chat/color/add",
    getChatHighlightColorList: API + "/chat/color/list",
    deleteChatHighlightColor: API + "/chat/color/delete/",
    toggleAIFeature: API + "/chat/product/update-ai-status/",
    updateAISwitchMessageCount: API + "/chat/product/update-ai-message-count/",

    // CHAT DOCUMENTATION
    getChatCDN: API + "/chat/product/chat-cdn",
    getChatDomain: API + "/chat/product/chat-domain",
    removeChatIntegration: API + "/chat/product/remove-domain",
}